export default __webpack_public_path__ + "static/media/nutritionfacts@3x.2aecdc19.jpg";